export default __webpack_public_path__ + "static/media/textToHTMLSherlock.aa768895.png";